const DIFFICULT_ACTIVITY_COINS_REWARD = 5

export default DIFFICULT_ACTIVITY_COINS_REWARD
